import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLangCsIconmin = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#a)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.217 9s-5.576 6.365-5.581 6.364A9 9 0 0 0 18 9H8.217Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.636 2.636a9 9 0 0 0 0 12.728L9 9 2.636 2.636Z",
				fill: "#0052B4"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h18v18H0z"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgLangCsIconmin);
export { ForwardRef as ReactComponent };
